import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'np-dialog-set-timeout',
  templateUrl: './dialog-set-timeout.component.html',
  styleUrls: ['./dialog-set-timeout.component.scss']
})
export class DialogSetTimeoutComponent implements OnInit {
  timer: string;
  constructor(public dialogRef: MatDialogRef<DialogSetTimeoutComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit() {
    this.countdownTimer();
  }
  reset() {
    this.dialogRef.close(true);
  }

  countdownTimer() {
    let idr;
    const end = new Date(Date.now() + 61000);
    this.timer = '61';
    const tick = () => {
      const now = new Date();
      if (+now > +end) {
        cancelAnimationFrame(idr);
        this.dialogRef.close(false);
        return;
      }
      this.timer = parseInt((+end - +now) / 1000 + '', 10) + '';
      setTimeout(() => {
        requestAnimationFrame(tick);
      }, 33);
    };
    idr = requestAnimationFrame(tick);
  }
}
